export const playVideo = () => {
  document.querySelectorAll(".video-wrapper").forEach((video) => {
    video.addEventListener("click", function () {
      const id = this.dataset.video;

      this.innerHTML = `
            <iframe
                width="100%"
                height="500"
                src="https://www.youtube.com/embed/${id}?autoplay=1&controls=0"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen>
            </iframe>
        `;
    });
  });
};
